export default __webpack_public_path__ + "static/media/Ooty3.3e43866e.jpg";